import styled from 'styled-components';

export const PageToggle = styled.div`
    margin-left: 50%;`